import { lazy } from 'react';

const StorefrontHomeLayoutRoutes = [
  {
    path: 'storefront/home-layout/section/add',
    component: lazy(() => import('views/storefront-home-layout/section-add')),
  },
  {
    path: 'storefront/home-layout/section/new/:type',
    component: lazy(() => import('views/storefront-home-layout/section-form-page')),
  },
  {
    path: 'storefront/home-layout/section/edit/:uuid',
    component: lazy(() => import('views/storefront-home-layout/section-form-page')),
  },
  {
    path: 'storefront/home-layout',
    component: lazy(() => import('views/storefront-home-layout')),
  },
];

export default StorefrontHomeLayoutRoutes;
